import { Avatar, Stack, Tooltip, Typography } from '@mui/material';

export interface ResourceDetailedItemProps {
  icon?: string;
  iconLocation?: 'flex-start' | 'center';
  displayName: string;
  logicalPath?: string;
  literalPath?: string;
}

function DisplayName({ text, maxLength }: { text: string; maxLength: number }) {
  if (text.length > maxLength) {
    let display = text.slice(-(maxLength - 3));
    const index = display.indexOf('/');
    if (index !== -1) {
      display = `${display.slice(index)}`;
    }
    return (
      <Tooltip title={text}>
        <Typography variant="body2" noWrap fontWeight={700}>
          ...{display}
        </Typography>
      </Tooltip>
    );
  } else {
    return (
      <Typography variant="body2" noWrap fontWeight={700}>
        {text}
      </Typography>
    );
  }
}

export default function ResourceDetailedItem({
  icon,
  displayName,
  logicalPath,
  literalPath,
}: ResourceDetailedItemProps) {
  return (
    <Stack width="100%" direction="row" spacing={1} alignItems="center">
      {icon && <Avatar src={icon} sx={{ width: 14, height: 14 }} variant="square" />}
      <Stack direction="column" spacing={0.25}>
        <DisplayName text={displayName} maxLength={65} />

        {(logicalPath || literalPath) && (
          <Stack>
            {logicalPath && (
              <Typography variant="inputLabel" color="text.muted">
                {logicalPath}
              </Typography>
            )}
            {literalPath && (
              <Typography variant="inputLabel" color="text.muted">
                {literalPath}
              </Typography>
            )}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}
